<span
  class="course-option-row"
  [class.course-option-row--newly-added]="
    highlightedCourseOption === courseOption
  "
>
  <span class="course-option-row__text">
    {{ courseOption }}
  </span>
  @if (highlightedCourseOption === courseOption) {
    <span class="course-option-row__tag">NEW</span>
  }
</span>
